/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect } from 'react';
import { useSearchSchedule } from 'features/searchSchedule';
import { useInvisibleCaptcha } from 'features/yaSmartCaptcha';
import { SearchInputMain, Slider } from 'widgets/index';

import styles from './styles.module.scss';

export const PageMain: FC = () => {
  const {
    groups,
    teachers,
    groupsIsLoading,
    teachersIsLoading,
    options,
    searchText,
    setOptions,
    makeOptions,
    handleChange,
    handleFocus,
    handleSelect,
    handleInputClearClick,
  } = useSearchSchedule('main');

  const { captchaStatus } = useInvisibleCaptcha();

  useEffect(() => {
    if (groups?.length) {
      setOptions(makeOptions(groups));
    } else if (teachers?.length) {
      setOptions(makeOptions(teachers));
    } else {
      setOptions(makeOptions());
    }
  }, [groups, teachers]);

  const isLoading =
    teachersIsLoading ||
    groupsIsLoading ||
    (!!searchText && captchaStatus !== 'success');

  return (
    <div className={styles['page']}>
      <Slider />
      <SearchInputMain
        className={styles['page__search-dropdown']}
        placeholder="Введите группу или фамилию преподавателя"
        onChange={handleChange}
        onFocus={handleFocus}
        onSelect={handleSelect}
        onClearClick={handleInputClearClick}
        isLoading={isLoading}
        options={options}
        value={searchText}
      />
    </div>
  );
};
